// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction4_wrapper__NdC74","button":"introduction4_button__ahLKa"};